// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2hPjX","colCheckbox":"styles_colCheckbox__ZDs_u"};